import { Fragment, useMemo } from "react";
import { InlineCtaBanner } from "@/components/resources/CtaBlock";

/** Split rendered article HTML into sections at each <h2> so we can inject
 *  periodic CTAs between sections (CRO). Returns array of HTML strings. */
function splitByH2(html) {
  if (!html) return [];
  const parts = html.split(/(?=<h2[\s>])/i).map((s) => s.trim()).filter(Boolean);
  return parts.length ? parts : [html];
}

/**
 * Renders the article body with editorial typography and inserts a compact
 * primary CTA after every `ctaEvery` sections (never right before the bottom
 * CTA block). The first chunk carries data-testid="resource-body".
 */
export function ResourceArticleBody({ html, primaryCta, secondaryCta, ctaEvery = 2 }) {
  const sections = useMemo(() => splitByH2(html), [html]);
  if (!sections.length) return null;

  return (
    <div className="mt-8">
      {sections.map((chunk, i) => {
        const isLast = i === sections.length - 1;
        const showCta = !isLast && (i + 1) % ctaEvery === 0 && !!primaryCta;
        return (
          <Fragment key={i}>
            <div
              className="resource-article-body"
              style={i > 0 ? { marginTop: "2.25rem" } : undefined}
              data-testid={i === 0 ? "resource-body" : undefined}
              dangerouslySetInnerHTML={{ __html: chunk }}
            />
            {showCta ? (
              <InlineCtaBanner primary={primaryCta} secondary={secondaryCta} testid={`resource-cta-mid-${i}`} />
            ) : null}
          </Fragment>
        );
      })}
    </div>
  );
}
